import { jsx as _jsx } from "react/jsx-runtime";
import notification from 'antd/es/notification';
import React, { useCallback, useContext, useEffect, useState, } from 'react';
import LoadingScreen from '../../../components/loading/screen';
import chunkArray from '../../helpers/chunk-array';
import useDebounceFunction from '../../hooks/use-debounce-function';
import useLocale from '../locale-provider';
import { usePlatform } from '../platform-provider';
import TranslationsProvider from '../translations-provider';
import { flattenTranslations, processTranslationFiles, } from '../translations-provider/translations-utils';
const FILE_CHUNK_SIZE = 100;
export const AppTranslationsContext = React.createContext({
    translationsData: {},
    isLoading: false,
});
const AppTranslationsProvider = ({ children, translationsFiles, }) => {
    const { selectedLocale } = useLocale();
    const [translationsData, setTranslationsData] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const { contentfulClient2 } = usePlatform();
    const fetchFiles = useDebounceFunction(useCallback(async () => {
        var _a;
        if (!translationsFiles.length || !contentfulClient2)
            return;
        setIsLoading(true);
        try {
            const fileChunks = chunkArray(translationsFiles, 100);
            const allTranslations = {};
            for (const fileChunk of fileChunks) {
                const filesResponse = await contentfulClient2.getEntries(Object.assign(Object.assign({}, { ['fields.key[in]']: fileChunk.join(',') }), { content_type: 'translationFile', locale: selectedLocale, limit: 100 }));
                const files = (_a = filesResponse.items) !== null && _a !== void 0 ? _a : [];
                const mapped = processTranslationFiles(files);
                const flattened = flattenTranslations([mapped]);
                Object.assign(allTranslations, flattened);
            }
            setTranslationsData((prev) => (Object.assign(Object.assign({}, prev), allTranslations)));
        }
        catch (error) {
            notification.error({
                message: 'Translations failed',
                description: error.message,
                placement: 'bottomLeft',
            });
            console.error(error.message);
        }
        finally {
            setIsLoading(false);
        }
    }, [selectedLocale, translationsFiles]), 500, true);
    useEffect(() => {
        if (!contentfulClient2)
            return;
        fetchFiles();
    }, [contentfulClient2, fetchFiles]);
    if (isLoading)
        return _jsx(LoadingScreen, {});
    return (_jsx(AppTranslationsContext.Provider, { value: { translationsData, isLoading }, children: _jsx(TranslationsProvider, { children: children }) }));
};
export const useAppTranslations = () => useContext(AppTranslationsContext);
export default AppTranslationsProvider;
